module.exports = __webpack_public_path__ + "img/Pre.8be21d86.gif";